const actions = {
  LISTING_BEGIN: 'LISTING_BEGIN',
  LISTING_SUCCESS: 'LISTING_SUCCESS',
  LISTING_ERR: 'LISTING_ERR',

  LISTING_CREATE_UPDATE_BEGIN: 'LISTING_CREATE_UPDATE_BEGIN',
  LISTING_CREATE_UPDATE_SUCCESS: 'LISTING_CREATE_UPDATE_SUCCESS',
  LISTING_CREATE_UPDATE_ERR: 'LISTING_CREATE_UPDATE_ERR',

  GET_LISTING_BEGIN: 'GET_HOST_BEGIN',
  GET_LISTING_SUCCESS: 'GET_HOST_SUCCESS',
  GET_LISTING_ERR: 'GET_HOST_ERR',

  LISTING_DELETE_BEGIN: 'LISTING_DELETE_BEGIN',
  LISTING_DELETE_SUCCESS: 'LISTING_DELETE_SUCCESS',
  LISTING_DELETE_ERR: 'LISTING_DELETE_ERR',

  HOST_PARTNER_COVERAGE_BEGIN: 'HOST_PARTNER_COVERAGE_BEGIN',
  HOST_PARTNER_COVERAGE_SUCCESS: 'HOST_PARTNER_COVERAGE_SUCCESS',
  HOST_PARTNER_COVERAGE_ERR: 'HOST_PARTNER_COVERAGE_ERR',

  DOWNLOAD_QRCODE_BEGIN: 'DOWNLOAD_QRCODE_BEGIN',
  DOWNLOAD_QRCODE_SUCCESS: 'DOWNLOAD_QRCODE_SUCCESS',
  DOWNLOAD_QRCODE_ERR: 'DOWNLOAD_QRCODE_ERR',

  LISTING_CONTENT_BEGIN: 'LISTING_CONTENT_BEGIN',
  LISTING_CONTENT_SUCCESS: 'LISTING_CONTENT_SUCCESS',
  LISTING_CONTENT_ERR: 'LISTING_CONTENT_ERR',

  CREATE_CHAT_STATUS_BEGIN: 'CREATE_CHAT_STATUS_BEGIN',
  CREATE_CHAT_STATUS_SUCCESS: 'CREATE_CHAT_STATUS_SUCCESS',
  CREATE_CHAT_STATUS_ERR: 'CREATE_CHAT_STATUS_ERR',

  EXPORT_LISTING_DATA_BEGIN: 'EXPORT_LISTING_DATA_BEGIN',
  EXPORT_LISTING_DATA_SUCCESS: 'EXPORT_LISTING_DATA_SUCCESS',
  EXPORT_LISTING_DATA_ERR: 'EXPORT_LISTING_DATA_ERR',

  FETCH_THEME_NAME_BY_HOST_BEGIN: 'FETCH_THEME_NAME_BY_HOST_BEGIN',
  FETCH_THEME_NAME_BY_HOST_SUCCESS: 'FETCH_THEME_NAME_BY_HOST_SUCCESS',
  FETCH_THEME_NAME_BY_HOST_ERR: 'FETCH_THEME_NAME_BY_HOST_ERR',

  LISTING_KNOWLEDGE_BASE_DETAILS_BEGIN: 'LISTING_KNOWLEDGE_BASE_DETAILS_BEGIN',
  LISTING_KNOWLEDGE_BASE_DETAILS_SUCCESS: 'LISTING_KNOWLEDGE_BASE_DETAILS_SUCCESS',
  LISTING_KNOWLEDGE_BASE_DETAILS_ERR: 'LISTING_KNOWLEDGE_BASE_DETAILS_ERR',

  SMART_TV_PAIRING_CODE_BEGIN: 'SMART_TV_PAIRING_CODE_BEGIN',
  SMART_TV_PAIRING_CODE_SUCCESS: 'SMART_TV_PAIRING_CODE_SUCCESS',
  SMART_TV_PAIRING_CODE_ERR: 'SMART_TV_PAIRING_CODE_ERR',

  SMART_TV_DEVICES_BEGIN: 'SMART_TV_DEVICES_BEGIN',
  SMART_TV_DEVICES_SUCCESS: 'SMART_TV_DEVICES_SUCCESS',
  SMART_TV_DEVICES_ERR: 'SMART_TV_DEVICES_ERR',

  SMART_TV_UNLINK_BEGIN: 'SMART_TV_UNLINK_BEGIN',
  SMART_TV_UNLINK_SUCCESS: 'SMART_TV_UNLINK_SUCCESS',
  SMART_TV_UNLINK_ERR: 'SMART_TV_UNLINK_ERR',

  listingBegin: () => {
    return {
      type: actions.LISTING_BEGIN,
    };
  },
  listingSuccess: (data) => {
    return {
      type: actions.LISTING_SUCCESS,
      data,
    };
  },

  listingErr: (err) => {
    return {
      type: actions.LISTING_ERR,
      err,
    };
  },
  listingDetailBegin: () => {
    return {
      type: actions.GET_LISTING_BEGIN,
    };
  },
  listingDetailSuccess: (data) => {
    return {
      type: actions.GET_LISTING_SUCCESS,
      data,
    };
  },

  listingDetailErr: (err) => {
    return {
      type: actions.GET_LISTING_ERR,
      err,
    };
  },
  listingDeleteBegin: () => {
    return {
      type: actions.LISTING_DELETE_BEGIN,
    };
  },
  listingDeleteSuccess: (data) => {
    return {
      type: actions.LISTING_DELETE_SUCCESS,
      data,
    };
  },
  listingDeleteErr: (err) => {
    return {
      type: actions.LISTING_DELETE_ERR,
      err,
    };
  },
  createOrUpdateListingBegin: () => {
    return {
      type: actions.LISTING_CREATE_UPDATE_BEGIN,
    };
  },
  createOrUpdateListingSuccess: (data) => {
    return {
      type: actions.LISTING_CREATE_UPDATE_SUCCESS,
      data,
    };
  },
  createOrUpdateListingErr: (err) => {
    return {
      type: actions.LISTING_CREATE_UPDATE_ERR,
      err,
    };
  },
  hostPartnerCoverageBegin: () => {
    return {
      type: actions.HOST_PARTNER_COVERAGE_BEGIN,
    };
  },
  hostPartnerCoverageSuccess: (data) => {
    return {
      type: actions.HOST_PARTNER_COVERAGE_SUCCESS,
      data,
    };
  },
  hostPartnerCoverageErr: (err) => {
    return {
      type: actions.HOST_PARTNER_COVERAGE_ERR,
      err,
    };
  },
  downloadQrcodeBegin: () => {
    return {
      type: actions.DOWNLOAD_QRCODE_BEGIN,
    };
  },
  downloadQrcodeSuccess: (data) => {
    return {
      type: actions.DOWNLOAD_QRCODE_SUCCESS,
      data,
    };
  },
  downloadQrcodeErr: (err) => {
    return {
      type: actions.DOWNLOAD_QRCODE_ERR,
      err,
    };
  },
  listingContentBegin: () => {
    return {
      type: actions.LISTING_CONTENT_BEGIN,
    };
  },
  listingContentSuccess: (data) => {
    return {
      type: actions.LISTING_CONTENT_SUCCESS,
      data,
    };
  },

  listingContentErr: (err) => {
    return {
      type: actions.LISTING_CONTENT_ERR,
      err,
    };
  },
  chatStatusBegin: () => {
    return {
      type: actions.CREATE_CHAT_STATUS_BEGIN,
    };
  },
  chatStatusSuccess: (data) => {
    return {
      type: actions.CREATE_CHAT_STATUS_SUCCESS,
      data,
    };
  },
  chatStatusErr: (err) => {
    return {
      type: actions.CREATE_CHAT_STATUS_ERR,
      err,
    };
  },
  exportListingDataBegin: () => {
    return {
      type: actions.EXPORT_LISTING_DATA_BEGIN,
    };
  },
  exportListingDataSuccess: (data) => {
    return {
      type: actions.EXPORT_LISTING_DATA_SUCCESS,
      data,
    };
  },
  exportListingDataErr: (err) => {
    return {
      type: actions.EXPORT_LISTING_DATA_ERR,
      err,
    };
  },

  nearbyPlacesBegin: () => {
    return {
      type: actions.LISTING_BEGIN,
    };
  },

  nearbyPlacesSuccess: (data) => {
    return {
      type: actions.LISTING_SUCCESS,
      data,
    };
  },
  
  nearbyPlacesErr: (err) => {
    return {
      type: actions.LISTING_ERR,
      err,
    };
  },

  fetchThemebyHostBegin: () => {
    return {
      type: actions.FETCH_THEME_NAME_BY_HOST_BEGIN,
    };
  },

  fetchThemebyHostSuccess: (data) => {
    return {
      type: actions.FETCH_THEME_NAME_BY_HOST_SUCCESS,
      data,
    };
  },
  
  fetchThemebyHostErr: (err) => {
    return {
      type: actions.FETCH_THEME_NAME_BY_HOST_ERR,
      err,
    };
  },

  listingKnowledgeBaseDetailsBegin: () => {
    return {
      type: actions.LISTING_KNOWLEDGE_BASE_DETAILS_BEGIN,
    };
  },
  listingKnowledgeBaseDetailsSuccess: (data) => {
    return {
      type: actions.LISTING_KNOWLEDGE_BASE_DETAILS_SUCCESS,
      data,
    };
  },
  listingKnowledgeBaseDetailsErr: (err) => {
    return {
      type: actions.LISTING_KNOWLEDGE_BASE_DETAILS_ERR,
      err,
    };
  },

  smartTvPairingCodeBegin: () => {
    return {
      type: actions.SMART_TV_PAIRING_CODE_BEGIN,
    };
  },
  smartTvPairingCodeSuccess: (data) => {
    return {
      type: actions.SMART_TV_PAIRING_CODE_SUCCESS,
      data,
    };
  },
  smartTvPairingCodeErr: (err) => {
    return {
      type: actions.SMART_TV_PAIRING_CODE_ERR,
      err,
    };
  },
  smartTvDevicesBegin: () => {
    return {
      type: actions.SMART_TV_DEVICES_BEGIN,
    };
  },
  smartTvDevicesSuccess: (data) => {
    return {
      type: actions.SMART_TV_DEVICES_SUCCESS,
      data,
    };
  },
  smartTvDevicesErr: (err) => {
    return {
      type: actions.SMART_TV_DEVICES_ERR,
      err,
    };
  },
  smartTvUnlinkBegin: () => {
    return {
      type: actions.SMART_TV_UNLINK_BEGIN,
    };
  },
  smartTvUnlinkSuccess: (data) => {
    return {
      type: actions.SMART_TV_UNLINK_SUCCESS,
      data,
    };
  },
  smartTvUnlinkErr: (err) => {
    return {
      type: actions.SMART_TV_UNLINK_ERR,
      err,
    };
  },

};
export default actions;
